import axios from 'axios';
import { getAccessToken } from '../context';
import { sleep } from '../util/sleep';

// Fire-and-forget Truvolv 'Form Errored' when a request fails for a technical reason (5xx /
// network, after retries are exhausted) — not for 4xx/validation, which is Form Invalid. Guarded
// against recursion so a failing beacon can't report itself. The backend no-ops for non-Truvolv
// orgs, so this is safe to call unconditionally.
function reportFormErrored(path) {
  if (typeof path === 'string' && (path.includes('truvolv-event') || path.includes('truvolv-form-start'))) return;
  try {
    makeRequest('post', 'appointment/page/api/truvolv-event', { event: 'form-errored' }, undefined, false, 0);
  } catch {
    /* ignore */
  }
}

export async function makeRequest(method, path, data, id, isForm, retries = 4) {
  try {
    const url = `${process.env.REACT_APP_HEAVYSET_API}/${path}${id ? `/${id}` : ''}`;
    let response;
    const headers = {
      Authorization: `Bearer ${getAccessToken()}`
    };
    if (isForm) {
      headers['Content-Type'] = 'multipart/form-data';
    }
    if (method === 'delete') {
      response = await axios.delete(url, { headers });
    } else {
      response = await axios[method](url, data, { headers });
    }
    return { data: response.data };
  } catch (ex) {
    const status = ex.response?.status;
    const shouldRetryAll = status === 502 || status === 503 || ex.message.includes('ECONNRESET') || !status;
    if (retries > 0) {
      await sleep(500);
      return await makeRequest(method, path, data, id, isForm, shouldRetryAll ? retries - 1 : 0);
    }
    // Retries exhausted: report only genuine technical failures (server/network), not 4xx input.
    if (status >= 500 || !status) {
      reportFormErrored(path);
    }
    return {
      errorMessage: ex.response?.data?.message || ex.message || 'error',
      errorField: ex.response?.data?.field || null
    };
  }
}
